import { useQuery } from '@tanstack/react-query'
import { OpalApiResponseDocument } from '../../schema'
import { everyoneSocialSettings } from '../../v3/everyoneSocialSettings'
import { globalQueryKeys } from '../queryKeys'
import { type EveryoneSocialSettings } from './types'

// A workspace has one settings resource once EveryoneSocial is provisioned
// for it, so `null` means the integration is not provisioned there.
const selectSettings = (
  document: OpalApiResponseDocument<'ReadEveryoneSocialSettingsV3', 200>
): EveryoneSocialSettings | null => {
  const resource = document.data[0]
  if (!resource) return null

  return {
    id: resource.id,
    contentUrlCustomFieldId: resource.attributes.content_url_custom_field_id,
    publishingStatusCustomFieldId:
      resource.attributes.publishing_status_custom_field_id,
    publishingStatusPublishedOptionId:
      resource.attributes.publishing_status_published_option_id,
  }
}

export function useEveryoneSocialSettings({
  workspaceUuid,
}: {
  workspaceUuid: string
}) {
  return useQuery({
    queryKey: globalQueryKeys.everyoneSocialSettings(workspaceUuid),
    queryFn: () =>
      everyoneSocialSettings.readCollection({
        params: { query: { filter: { workspace_id: workspaceUuid } } },
      }),
    select: selectSettings,
  })
}
